<section class="ti-page">

  <!-- ── En-tête de page ── -->
  <header class="ti-page__header">
    <div class="ti-page__header-text">
      <div class="ti-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
          <rect x="9" y="3" width="6" height="4" rx="1"/>
          <line x1="9" y1="12" x2="15" y2="12"/>
          <line x1="9" y1="16" x2="13" y2="16"/>
        </svg>
      </div>
      <div>
        <h1 class="ti-page__title">Types d'intervention</h1>
        <p class="ti-page__subtitle">Gérez les types d'intervention de votre application.</p>
      </div>
    </div>

    <app-ui-button
      label="Ajouter un type"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddTypeInterventionModal()"
    ></app-ui-button>
  </header>

  <!-- ── Card / Table ── -->
  <div class="ti-table-card">
    @if (isLoading) {
      <div class="ti-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="ti-table-card__toolbar">
        <div class="ti-table-card__toolbar-left">
          <span class="ti-badge">{{ typeInterventions.length }}</span>
          <span class="ti-table-card__count">enregistrement{{ typeInterventions.length > 1 ? 's' : '' }}</span>
        </div>
      </div>

      @if (!typeInterventions.length) {
        <div class="ti-empty">
          <div class="ti-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
              <rect x="9" y="3" width="6" height="4" rx="1"/>
              <line x1="9" y1="12" x2="15" y2="12"/>
              <line x1="9" y1="16" x2="13" y2="16"/>
            </svg>
          </div>
          <p class="ti-empty__title">Aucun type d'intervention</p>
          <p class="ti-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableTypeIntervention"
          [data]="typeInterventions"
          [actions]="rowActions"
        ></app-ui-table>
      }
    }
  </div>

  <!-- ── Template des actions par ligne ── -->
  <ng-template #rowActions let-item="item">
    <div class="ti-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditTask(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</section>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal ajout / édition -->
<app-modal
  [isVisible]="showAddTypeInterventionModal"
  [title]="isEditing ? 'Modifier le type' : 'Nouveau type d\'intervention'"
  (closeEvent)="closeAddTypeInterventionModal()"
>
  <form [formGroup]="typeInterventionForm" (ngSubmit)="save()" class="ti-form">

    @if (isEditing && editingTypeIntervention) {
      <div class="ti-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingTypeIntervention.libelle }}</strong>
      </div>
    }

    <div class="ti-form__fields">
      <div class="ti-form__field">
        <app-input
          label="Libellé"
          placeholder="Ex : Intervention urgente"
          type="text"
          formControlName="libelle"
        />
        @if (typeInterventionForm.get('libelle')?.invalid && (typeInterventionForm.get('libelle')?.dirty || typeInterventionForm.get('libelle')?.touched)) {
          <span class="ti-form__error">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Le libellé est requis.
          </span>
        }
      </div>

      <div class="ti-form__field">
        <app-input
          label="Niveau de priorité"
          placeholder="Ex : 1"
          type="number"
          formControlName="niveau"
        />
        @if (typeInterventionForm.get('niveau')?.invalid && (typeInterventionForm.get('niveau')?.dirty || typeInterventionForm.get('niveau')?.touched)) {
          <span class="ti-form__error">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Le niveau de priorité est requis.
          </span>
        }
      </div>
    </div>

    <div class="ti-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeAddTypeInterventionModal()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || typeInterventionForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>